export class Filtro {
    adulto: any;
    nino: any;
    estacas: any;
    jardines: any;
    hacienda: any;
    zoofari: any;
    inicio: any;
    fin: any;
    texto: any;
    tipoBusqueda: any;
}

export class Consulta {
    idUsuario: any;
    token: any;
    restriciones: any;
}

export class Venta {
    boletin: any;
    contrasenia: any;
    correo: any;
    estatus: any;
    id: any;
    nombre: any;
    primerApellido: any;
    segundoApellido: any;
    token: any;
    idUsuario: any;
}

export class Detalle {
    correo: any;
    estatus: any;
    fechaFin: any;
    fechaInicio: any;
    fechaUso: any;
    id: any;
    idEmpresa: any;
    idPaquete: any;
    idProducto: any;
    idTipoPase: any;
    idUsuario: any;
    idUsuarioEmpresa: any;
    idVenta: any;
    nombre: any;
    nota: any;
    primerapellido: any;
    segundoapellido: any;
    titular: any;
    token: any;
}


// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/conf/clases.ts